import type { VNode } from "vue";
import { h } from "vue";

import type { ValidationError } from "../models";
import { getFailureMessage } from "../types/validationFailure";

/**
 * Returns a render function that can be used for an anonymous component definition
 * to be used as toast content.
 * @param error The validation error instance
 */
export const createValidationErrorToastRenderFn = (
  error: ValidationError,
  showFailures = false,
) => {
  const childNodes: (string | VNode)[] = ["Action did not succeed!"];
  if (showFailures) {
    childNodes.push(
      ...error.failures.flatMap((f) => [h("br"), getFailureMessage(f)]),
    );
  }

  return () => h("span", childNodes);
};
